import React from 'react'
import PropTypes from 'prop-types'
import { HashLink as Link } from 'react-router-hash-link'

import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import styles from './styles.scss'

const HashLink = (props) => {
  const {
    children,
    options,
  } = props

  const {
    anchor,
  } = options

  const style = deviceStyle(props)

  return (
    <AnimationWrapper options={options}>
      <div
        className={styles.root}
        style={style}
      >
        <Link
          smooth
          to={`#${anchor}`}
        >
          {children}
        </Link>
      </div>
    </AnimationWrapper>
  )
}

HashLink.propTypes = {
  children: PropTypes.node,
  options: PropTypes.object,
}

HashLink.defaultProps = {
  options: {},
}

export default HashLink
